import * as types from '@/store/mutation-types';
import inspectionApi from '@/store/inspection/inspectionApi';
import { logAction } from '@/store/logActions';
import { editingAllowed } from '@/store/actions';
import log from '@/logger';

export const getInspection = (ctx, id) => {
  log.debug('actions:getInspection', id);

  return inspectionApi.getInspection(id);
};

export const addInspection = async (
  { commit, state, dispatch },
  { address, projectId, partId, inspectionTemplateId, beginTime, endTime, participants }
) => {
  log.debug('inspectionActions:addInspection', inspectionTemplateId);

  if (!editingAllowed(state)) {
    return;
  }

  const template = await dispatch('getInspectionTemplate', inspectionTemplateId);

  const values = {
    inspectionTemplateId,
    address,
    beginTime,
    endTime,
    participants,
    title: template.title,
    /** @todo Clone deep */
    sections: template.sections ? [...template.sections] : [],
    failureOptions: template.failureOptions ? [...template.failureOptions] : [],
    priorities: template.priorities ? [...template.priorities] : [],
    projectId,
    partId,
  };

  try {
    const inspection = await inspectionApi.createInspection(values);
    commit(types.addInspection, { inspection });
    logAction({ commit, state }, { project: state.currentProject, object: inspection, reason: 'Added Inspection' });

    return inspection;
  } catch (error) {
    log.error('inspectionActions:addInspection', error);
    commit(types.setSyncStatus, { status: 'Error', live: 0, message: 'Database Error occurred', count: 1 });
  }
};

export const updateInspectionParticipantSelection = async (
  { dispatch, state },
  { updateInspection, selection, reason }
) => {
  log.debug('inspectionActions:updateInspectionParticipantSelection', { updateInspection, selection });

  if (!editingAllowed(state) || !selection) {
    return;
  }
  const update = {
    updateInspection,
    reason,
    newInspectionProperties: {
      participants: updateInspection.participants.map((participant) => {
        const item = selection.find(({ personId }) => personId === participant.personId);
        return item ? { ...participant, participates: item.selected } : participant;
      }),
    },
  };

  return dispatch('saveInspectionProperties', update);
};

export const addInspectionParticipant = async ({ commit, state, getters }, update) => {
  log.debug('actions:addInspectionParticipant', JSON.stringify(update, '', '  '));

  if (!editingAllowed(state)) {
    return;
  }

  const person = update.person;
  const company = getters.getCompany(person.companyId);
  const participant = {
    personId: person._id,
    firstName: person.firstName,
    lastName: person.lastName,
    companyId: company._id,
    companyName: company.companyName,
    email: person.email,
    participates: true,
  };

  const reason = logAction(
    { commit, state },
    {
      project: state.currentProject,
      object: update.updateInspection,
      reason: 'Added Inspection Participant',
      update: participant,
    }
  );

  commit(types.addInspectionParticipant, { updateInspection: update.updateInspection, participant });

  try {
    const entity = inspectionApi.saveInspection(update.updateInspection, reason);
    update.newInspectionProperties = entity;
    commit(types.setInspectionProperties, update);
    return entity;
  } catch (error) {
    log.error('Error when saving inspection', error);
    commit(types.setSyncStatus, { status: 'Error', live: 0, message: 'Database Error occurred', count: 1 });
  }
};

export const saveInspectionProperties = async ({ commit, state }, update) => {
  log.debug('actions:saveInspectionProperties', JSON.stringify(update, '', '  '));

  if (!editingAllowed(state)) {
    return;
  }

  const reason = logAction(
    { commit, state },
    {
      project: state.currentProject,
      object: update.updateInspection,
      reason: update.reason || 'Updated Inspection Properties',
      update: update.newInspectionProperties,
    }
  );

  setInspectionProperties({ commit, state }, update);

  try {
    const entity = inspectionApi.saveInspection(update.updateInspection, reason);
    update.newInspectionProperties = entity;
    commit(types.setInspectionProperties, update);
    return entity;
  } catch (error) {
    log.error('Error when saving inspection', error);
    commit(types.setSyncStatus, { status: 'Error', live: 0, message: 'Database Error occurred', count: 1 });
  }
};

export const syncInspection = ({ commit, state }, inspection) => {
  if (state.selectedPartInspection && state.selectedPartInspection._id === inspection._id) {
    commit(types.setSelectedPartInspection, inspection);
  }
};

export const setInspectionProperties = ({ commit, state }, update) => {
  if (!editingAllowed(state)) {
    return;
  }
  commit(types.setInspectionProperties, update);
};

export const fetchInspectionPdfUrl = async (_store, payload) => {
  const { url } = await inspectionApi.fetchInspectionPdfUrl(payload);
  return url;
};



// WEBPACK FOOTER //
// ./src/store/inspection/inspectionActions.js